module.exports = __webpack_public_path__ + "static/aplikacja-bankowa-b12200f55f0a19e5fb26b8c1d7adc7cd.jpg";